import {reqWithToken} from './requestHelper';


export async function isCollided(params){
    return (await reqWithToken('api/gxbooking/courseTimes/isCollided',{
        params
    })).data;
}

export async function submit(model){
    return (await reqWithToken('api/gxbooking/booking',{
        data: model,
        method: 'post'
    })).data;
}

export async function adminSubmit(model){
    return (await reqWithToken('api/gxbooking/booking/admin',{
        data: model,
        method: 'post'
    })).data;
}

export async function getVacancyRooms(params){
    return (await reqWithToken('api/gxbooking/classrooms/vacancy',{
        params
    })).data;
}

